<template>
<div>
<div class="sidenav">
  <b-nav vertical pills>
    <b-nav-item :active="active==='overview'" @click="active='overview'">
      Overview
    </b-nav-item>
    <!-- <b-nav-item :active="active==='getup'" @click="active='getup'">
      Starting with Flask and Google App Engine
    </b-nav-item>
    <b-nav-item :active="active==='vue'" @click="active='vue'">
      Use Vue as Front End
    </b-nav-item>
    <b-nav-item :active="active==='firestore'" @click="active='firestore'">
      Connect to Cloud Firestore Database
    </b-nav-item> -->
      <router-link tag="b-nav-item" to="/demo">Run a Psychology Study (coming soon)</router-link>
  </b-nav>
</div>

<div class="main">
  <navbar></navbar>
  <h3>PsychCloud</h3>
  <div v-if="active==='overview'"><overview></overview></div>
  <div v-if="active==='getup'"><getUp></getUp></div>
  <div v-if="active==='firestore'"><firestore></firestore></div>
  <div v-if="active==='vue'"><vueIntro></vueIntro></div>
</div>
</div>
</template>

<style>

body {
  font-family: "Lato", sans-serif;
}

.sidenav {
  height: 100%;
  width: 15%;
  position: fixed;
  top: 0;
  left: 0;
  background-color:#F8F9F9 ;
  overflow-x: hidden;
  padding-top: 20px;
  /* text-align: left; */
}

.sidenav a {
  padding: 10px 8px 6px 16px;
  text-decoration: none;
  color: #818181;
  display: block;
}

.sidenav a:hover {
  color: #379683;
}
.nav-pills .nav-link.active{
  background-color: #379683;
  text-align: left;
}
.nav-pills .nav-link{
  text-align: left;
}

.main {
  margin-left: 15%;
  padding: 0px 10px;
}

@media screen and (max-width: 400px) {
  .sidenav {display: none}
  .main {margin-left: 0%;}
}
</style>

<script>
import Nav from './Nav.vue';
import Firestore from './Home/Firestore.vue';
import Overview from './Home/Overview.vue';
import VueIntro from './Home/VueIntro.vue';
import GetUp from './Home/GetUp.vue';

export default {
  data() {
    return {
      active: 'overview',
    };
  },
  components: {
    navbar: Nav,
    firestore: Firestore,
    overview: Overview,
    vueIntro: VueIntro,
    getUp: GetUp,
  },
};
</script>
